/**
 * Kent Traders Advanced Search JavaScript
 * Handles search functionality, filters, and suggestions
 */

(function() {
  'use strict';
  
  class AdvancedSearch {
    constructor() {
      this.currentSearch = '';
      this.filters = {};
      this.init();
    }
    
    init() {
      this.initSearchSuggestions();
      this.initFilters();
      this.initActiveFilters();
      this.initPagination();
      this.initMobileFilters();
    }
    
    initSearchSuggestions() {
      const searchInput = document.querySelector('input[name="q"]');
      
      if (searchInput) {
        let debounceTimer;
        
        searchInput.addEventListener('input', (e) => {
          clearTimeout(debounceTimer);
          
          debounceTimer = setTimeout(() => {
            this.showSuggestions(e.target.value);
          }, 300);
        });
        
        searchInput.addEventListener('focus', () => {
          if (searchInput.value.length > 0) {
            this.showSuggestions(searchInput.value);
          }
        });
        
        // Hide suggestions when clicking outside
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.kt-search-suggestions')) {
            this.hideSuggestions();
          }
        });
      }
    }
    
    async showSuggestions(query) {
      if (query.length < 2) {
        this.hideSuggestions();
        return;
      }
      
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`);
        
        // Handle 422 and other non-ok responses gracefully
        if (response.status === 422) {
          // Return empty results for 422 errors
          this.hideSuggestions();
          return;
        }
        
        if (!response.ok) {
          this.hideSuggestions();
          return;
        }
        
        const data = await response.json();
        this.renderSuggestions(data, query);
      } catch (error) {
        // Silently handle errors - don't spam console
        this.hideSuggestions();
      }
    }
    
    renderSuggestions(data, query) {
      const suggestionsContainer = document.querySelector('[data-search-suggestions]');
      
      if (!suggestionsContainer) return;
      
      let suggestionsHTML = `
        <div class="kt-suggestions-header">
          <h3>Search Suggestions for "${query}"</h3>
        </div>
        <div class="kt-suggestions-content">
      `;
      
      if (data.resources.results.products.length > 0) {
        suggestionsHTML += `
          <div class="kt-product-suggestions">
            <h4>Products</h4>
            <div class="kt-suggestion-products">
        `;
        
        data.resources.results.products.forEach(product => {
          suggestionsHTML += `
            <a href="${product.url}" class="kt-suggestion-product">
              <img src="${product.featured_image}" alt="${product.title}">
              <div class="kt-suggestion-info">
                <h5>${product.title}</h5>
                <p class="kt-suggestion-price">${product.price}</p>
              </div>
            </a>
          `;
        });
        
        suggestionsHTML += `</div></div>`;
      }
      
      suggestionsHTML += `
        <div class="kt-search-suggestions-footer">
          <a href="/search?q=${encodeURIComponent(query)}" class="kt-view-all-results">
            View all results for "${query}"
          </a>
        </div>
      </div>`;
      
      suggestionsContainer.innerHTML = suggestionsHTML;
      suggestionsContainer.style.display = 'block';
    }
    
    hideSuggestions() {
      const suggestionsContainer = document.querySelector('[data-search-suggestions]');
      if (suggestionsContainer) {
        suggestionsContainer.style.display = 'none';
      }
    }
    
    initFilters() {
      const filterForm = document.querySelector('[data-filters-form]');
      
      if (filterForm) {
        filterForm.addEventListener('submit', (e) => {
          e.preventDefault();
          this.applyFilters();
        });
        
        // Auto-submit on filter change
        const autoSubmitFilters = filterForm.querySelectorAll('input[type="radio"], select');
        autoSubmitFilters.forEach(filter => {
          filter.addEventListener('change', () => {
            this.applyFilters();
          });
        });
      }
    }
    
    applyFilters() {
      const filterForm = document.querySelector('[data-filters-form]');
      const formData = new FormData(filterForm);
      
      // Get current search parameters
      const urlParams = new URLSearchParams(window.location.search);
      const searchQuery = urlParams.get('q') || '';
      
      // Build new URL with filters
      const newParams = new URLSearchParams();
      if (searchQuery) newParams.set('q', searchQuery);
      
      for (const [key, value] of formData.entries()) {
        if (value) newParams.set(key, value);
      }
      
      // Navigate to filtered results
      window.location.href = `/search?${newParams.toString()}`;
    }
    
    initActiveFilters() {
      const clearFiltersBtn = document.querySelector('[data-clear-filters]');
      
      if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener('click', () => {
          this.clearAllFilters();
        });
      }
    }
    
    clearAllFilters() {
      const urlParams = new URLSearchParams(window.location.search);
      const searchQuery = urlParams.get('q') || '';
      
      // Keep only the search query
      const newParams = new URLSearchParams();
      if (searchQuery) newParams.set('q', searchQuery);
      
      window.location.href = `/search?${newParams.toString()}`;
    }
    
    initPagination() {
      const paginationLinks = document.querySelectorAll('.kt-pagination a');
      
      paginationLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          
          // Track pagination click
          if (window.ktSearchAnalytics) {
            window.ktSearchAnalytics.logEvent('pagination_clicked', {
              page: link.textContent,
              url: link.href,
              timestamp: Date.now()
            });
          }
          
          window.location.href = link.href;
        });
      });
    }
    
    initMobileFilters() {
      const mobileFilterToggle = document.querySelector('[data-mobile-filters-toggle]');
      const filtersPanel = document.querySelector('[data-filters-panel]');
      
      if (mobileFilterToggle && filtersPanel) {
        mobileFilterToggle.addEventListener('click', () => {
          filtersPanel.classList.toggle('kt-filters-open');
        });
      }
    }
  }
  
  // Initialize advanced search
  document.addEventListener('DOMContentLoaded', () => {
    window.ktAdvancedSearch = new AdvancedSearch();
  });
  
})();
